import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class Haibao extends React.PureComponent {
    static propTypes = {
        hbType: PropTypes.string,
        handleMaskHide: PropTypes.func,
    };

    state = {
        haibaoImg: '',
        isShow: false,
    };

    componentDidMount() {
        this.handleScreen();
    }

    handleScreen = async () => {
        let html2canvas = await import('html2canvas');

        html2canvas = html2canvas.default;

        const { hbType } = this.props;

        const el = document.querySelector(`#${hbType === 'all' ? 'all' : 'area'}`);

        html2canvas(el, {
            useCORS: true,
            width: el.offsetWidth,
            height: el.offsetHeight,
            scrollX: 0,
            scrollY: 0,
            scale: 4,
        }).then(canvas => {
            const context = canvas.getContext('2d');

            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            this.setState({
                haibaoImg: canvas.toDataURL(),
                isShow: true,
            });
        });
    };

    render() {
        const { haibaoImg, isShow } = this.state;
        const { handleMaskHide } = this.props;

        return (
            <Fragment>
                <div className={styles.haibao}>
                    <div id="close" className={styles.close} onClick={handleMaskHide} />
                    {isShow && <img src={haibaoImg} />}
                </div>
                {isShow && (
                    <div id="tip" className={styles.tip}>
                        长按图片保存到手机
                    </div>
                )}
            </Fragment>
        );
    }
}

export default errorBoundary(Haibao);
